import Swup from 'swup';
import { initMotion, destroyMotion, resetAOSAnimations, refreshAOSHard } from './motion';

function isIgnorableLink(a) {
    const href = a.getAttribute('href') || '';
    if (!href) return true;
    if (href.startsWith('#')) return true;
    if (href.startsWith('mailto:')) return true;
    if (href.startsWith('tel:')) return true;
    if (a.hasAttribute('data-no-swup')) return true;
    if (a.getAttribute('target')) return true;
    return false;
}

function initSwup() {
    const container = document.getElementById('swup');
    if (!container) return;

    const overlay = document.getElementById('swup-overlay');

    const swup = new Swup({
        containers: ['#swup'],
        linkSelector: 'a[href]',
        cache: true,
    });

    // Overlay close/open effect (brand dark) — subtle + fast.
    swup.hooks.on('link:click', ({ el }) => {
        if (!overlay) return;
        if (!el || isIgnorableLink(el)) return;
        overlay.classList.add('is-active');
    });

    swup.hooks.on('content:replace', () => {
        // reset scroll
        window.scrollTo(0, 0);
        destroyMotion();
    });

    swup.hooks.on('page:view', () => {
        initMotion();
        document.dispatchEvent(new Event('rlm:pageview'));
        if (overlay) {
            // Ensure AOS doesn't "complete" behind the overlay
            resetAOSAnimations();
            overlay.classList.remove('is-active');
            // Wait for overlay animation (520ms) + a bit more, then refresh AOS
            setTimeout(() => {
                refreshAOSHard();
            }, 600);
        } else {
            // No overlay, refresh immediately
            setTimeout(() => refreshAOSHard(), 100);
        }
    });
}

document.addEventListener('DOMContentLoaded', initSwup);
